<div
  class="tile-container"
  role="button"
  tabindex="0"
  aria-label="Open document preview"
  [attr.aria-pressed]="libItem.selected"
  [ngClass]="{ selected: libItem.selected }"
  (click)="onClick()"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick(); $event.preventDefault()"
>
  <pdf-viewer
    [src]="source"
    [original-size]="false"
    [show-all]="false"
    [autoresize]="false"
    [render-text]="false"
    class="appear"
    [ngClass]="{ 'appear-now': loaded }"
    [zoom]="1.6"
    (page-rendered)="loaded = true"
    style="height: 100%"
  >
  </pdf-viewer>
  @if (!loaded) {
    <div class="loading">
      <mat-icon>insert_drive_file</mat-icon>
    </div>
  }
  @if (libItem.payload && loaded) {
    <div class="name-panel">
      @if (libItem.payload.patientData && libItem.payload.patientData.uid) {
        <span class="patient-id">
          {{ libItem.payload.patientData.uid }}
        </span>
      }
      @if (libItem.payload.creator) {
        <div class="name-box">
          <div class="font-grey font-12 by">by</div>
          <div class="name-field">
            @if (!ownFile) {
              <div class="celo-elipsis fw">
                {{ libItem.payload.creator.title }}
                {{ libItem.payload.creator.firstName }}
                {{ libItem.payload.creator.lastName }}
              </div>
            }
            @if (ownFile) {
              <div>You</div>
            }
          </div>
        </div>
      }
      @if (canSelect) {
        <mat-icon>{{
          libItem.selected ? "check_circle" : "radio_button_unchecked"
        }}</mat-icon>
      }
    </div>
  }
</div>
